export default __webpack_public_path__ + "static/media/23.2436a8d8.gif";